// extracted by mini-css-extract-plugin
export default {"modalbody":"FullscreenModal_modalbody__BUPbL","close-btn":"FullscreenModal_close-btn__oKAJb"};